// @ts-check
// Escopo por etapa do funil do papel atual nas telas (contrato de equipe, seção 3.2): opções de etapa dos seletores e
// dos filtros e a saída do card que foi para uma etapa que o papel não vê. A API é a barreira; aqui a tela só deixa de
// oferecer o que o servidor recusaria e tira da lista o que ele não devolveria mais.
import { currentUserPermissionsState, objectsById } from './metadata-store.js';
import { filterVisibleStageOptions, filterWritableStageOptions, funnelStageFieldKind, visibleFunnelStages } from '../lib/permissions.js';

/**
 * @typedef {import('../lib/field-metadata.js').FieldMetadata} FieldMetadata
 * @typedef {import('../lib/permissions.js').StageOption} StageOption
 */

/** @param {FieldMetadata} field */
export const stageFieldKindOf = (field) => funnelStageFieldKind(objectsById.value.get(field.objectMetadataId)?.nameSingular, field.name);

/**
 * Opções de um campo SELECT com o escopo do papel: WRITE (seletor de etapa do card e do aluno: Ver e Pode passar),
 * CREATE (card novo nasce em Ver) e FILTER (chips de filtro da etapa do card: só Ver). Outros campos não mudam.
 * @template {StageOption} TOption
 * @param {FieldMetadata} field @param {TOption[]} options @param {'WRITE' | 'CREATE' | 'FILTER'} mode @param {string | null} [currentValue]
 * @returns {Array<TOption & { isHandoff?: boolean }>}
 */
export function scopeStageOptions(field, options, mode, currentValue = null) {
  const kind = stageFieldKindOf(field);
  const permissions = currentUserPermissionsState.value;
  if (!kind || !permissions?.funnelStageScope) return options;
  if (mode === 'WRITE') return field.name === 'effectiveStage' ? options : filterWritableStageOptions(options, permissions, currentValue);
  if (kind !== 'CARD') return options;
  return filterVisibleStageOptions(options, permissions);
}

/**
 * O card ficou numa etapa fora de Ver (Pode passar, regra do motor como o check-in): sai da visão do papel.
 * @param {string} objectNameSingular @param {any} record
 */
export function isRecordOutsideStageScope(objectNameSingular, record) {
  if (objectNameSingular !== 'enrollmentOpportunity' || typeof record?.stage !== 'string') return false;
  const visible = visibleFunnelStages(currentUserPermissionsState.value);
  return Boolean(visible && !visible.has(record.stage));
}

/** O papel atual tem etapas restritas. */
export const hasStageScope = () => Boolean(currentUserPermissionsState.value?.funnelStageScope);
